import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-warning text-weight-bold text-uppercase"
}
const _hoisted_2 = {
  key: 0,
  class: "text-h6 text-center text-weight-regular q-mb-md"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accounts_loader = _resolveComponent("accounts-loader")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_site_icon = _resolveComponent("site-icon")!
  const _component_account = _resolveComponent("account")!
  const _component_import_posts = _resolveComponent("import-posts")!
  const _component_import_posts_btn = _resolveComponent("import-posts-btn")!
  const _component_app_user = _resolveComponent("app-user")!
  const _component_platform_switcher = _resolveComponent("platform-switcher")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_accounts_loader, {
      "client-id": _ctx.clientId,
      "model-value": _ctx.accounts,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:accounts', $event))),
      ref: "accounts"
    }, null, 8, ["client-id", "model-value"]),
    _createVNode(_component_platform_switcher, {
      platforms: _ctx.platforms,
      "model-value": _ctx.platform,
      onLoaded: _ctx.onPlatformsLoaded,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:platform', $event)))
    }, {
      header: _withCtx((scope) => [
        _createVNode(_component_q_item_section, { class: "text-body1" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({ 'text-weight-bold': scope.isActive })
            }, _toDisplayString(scope.platform.name), 3),
            (_ctx.isActionNeeded(scope.platform.id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Action Needed "))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      default: _withCtx(({ isSplit }) => [
        (_ctx.platform)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["bg-white full-height", { 'q-pt-md': isSplit }])
            }, [
              isSplit
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_site_icon, {
                      "social-site": _ctx.platform,
                      class: "on-left"
                    }, null, 8, ["social-site"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.platform.name) + " Account ", 1)
                  ]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ account: _ctx.getAccount(_ctx.platform.id) })), () => [
                (_ctx.getAccount(_ctx.platform.id))
                  ? (_openBlock(), _createBlock(_component_account, {
                      key: 0,
                      account: _ctx.getAccount(_ctx.platform.id),
                      class: "q-pa-sm",
                      "onUpdate:account": _ctx.set,
                      onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.accounts.load()))
                    }, null, 8, ["account", "onUpdate:account"]))
                  : (_openBlock(), _createBlock(_component_app_user, {
                      key: 1,
                      class: "q-pa-lg text-center text-body1"
                    }, {
                      default: _withCtx(({ isServiceProvider, isCustomer, isClient }) => [
                        isClient
                          ? (_openBlock(), _createBlock(_component_import_posts, {
                              key: 0,
                              "client-id": _ctx.clientId,
                              platform: _ctx.platform
                            }, null, 8, ["client-id", "platform"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createTextVNode(" No " + _toDisplayString(_ctx.platform.name) + " account was added by the client. ", 1),
                              _hoisted_4,
                              (isServiceProvider || isCustomer)
                                ? (_openBlock(), _createBlock(_component_import_posts_btn, {
                                    key: 0,
                                    platform: _ctx.platform,
                                    "client-id": _ctx.clientId,
                                    color: "primary",
                                    class: "q-mt-sm",
                                    rounded: ""
                                  }, null, 8, ["platform", "client-id"]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _: 1
                    }))
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["platforms", "model-value", "onLoaded"])
  ]))
}